import React, { useState } from "react";
import "./CustomerMobileModal.scss";

const CustomerMobileModal = ({ isOpen, onSubmit, storeName }) => {
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const cleanMobile = mobile.trim();

    if (!/^[6-9]\d{9}$/.test(cleanMobile)) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }

    setError("");
    onSubmit(cleanMobile);
  };

  return (
    <div className="mobile-modal-overlay">
      <div className="mobile-modal-card">
        <div className="icon-badge">📱</div>
        <h3 className="modal-title">Welcome to {storeName || "Our Restaurant"}</h3>
        <p className="modal-subtitle">
          Please enter your mobile number to view our digital menu and place your order.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label className="form-label text-start w-100 fw-semibold text-dark small">
              Mobile Number <span className="text-danger">*</span>
            </label>
            <div className="input-group">
              <span className="input-group-text bg-light fw-bold">+91</span>
              <input
                type="tel"
                className="form-control form-control-lg"
                placeholder="Enter 10-digit number"
                value={mobile}
                maxLength={10}
                onChange={(e) => {
                  setMobile(e.target.value.replace(/\D/g, ""));
                  setError("");
                }}
                autoFocus
                required
              />
            </div>
            {error && <small className="text-danger d-block mt-1 text-start fw-semibold">{error}</small>}
          </div>

          <button type="submit" className="btn btn-primary btn-lg w-100 submit-btn">
            Continue to Menu ➔
          </button>
        </form>

        <small className="text-muted d-block mt-3" style={{ fontSize: "12px" }}>
          🔒 Your contact details are securely used only for order notifications & updates.
        </small>
      </div>
    </div>
  );
};

export default CustomerMobileModal;
